// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"13442a317200c4642487","293":"fc5faf0a26a6b0c9aa58"}[chunkId] + ".js";
};